import { Illustration, IllustrationsList } from '@mint-lib/illustrations';

import {
  Empty,
  EmptyActions,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '../../lib/empty-state.jsx';

type Props = {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  size?: 'big' | 'medium';
  illustration?: IllustrationsList;
};

function EmptyState({
  title,
  description,
  actions,
  size = 'big',
  illustration = 'IllustrationEmptyState',
}: Readonly<Props>) {
  return (
    <Empty size={size}>
      <EmptyMedia data-size={size}>
        <Illustration
          data-testid={`empty-state-illustration-${illustration}`}
          component={illustration}
        />
      </EmptyMedia>
      <EmptyContent>
        <EmptyHeader>
          <EmptyTitle>{title}</EmptyTitle>
          <EmptyDescription>{description}</EmptyDescription>
        </EmptyHeader>
        {actions && <EmptyActions>{actions}</EmptyActions>}
      </EmptyContent>
    </Empty>
  );
}

export default EmptyState;
